import React, {useCallback, useMemo, useState} from 'react';
import Select from 'react-select';
import {
  Modal,
  customStyles,
  DropdownIndicator,
  PrimaryButton,
  SecondaryButton,
} from '../../components';
import {useAllApps} from '../../hooks/useApps';

import {useMutation, useQueryClient} from 'react-query';
import {addWebhookSubscription} from '../../requests/queries/Developers/webbhook';
import {toast} from 'react-toastify';

const SERVICES = [
  {label: 'SMS', value: 'sms', isDisabled: true},
  {label: 'NG Wallet', value: 'ngn_wallet'},
  {label: 'KYC Widget', value: 'kyc_widget'},
  {label: 'Aml Monitoring', value: 'aml'},
  {label: 'Address', value: 'address'},
];

export default function WebhookSubscribeModal({open, setOpen}) {
  const [selectedApp, setSelectedApp] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [webhookUrl, setWebhookUrl] = useState('');
  const {userApps: ALL_APPS} = useAllApps();
  const queryClients = useQueryClient();

  const data = useMemo(
    () => ({
      app_id: selectedApp?.value,
      service: selectedService?.value,
      webhook: webhookUrl,
    }),
    [selectedApp?.value, selectedService?.value, webhookUrl],
  );

  const {mutate, isLoading} = useMutation(addWebhookSubscription);

  const handeSubscribe = useCallback(() => {
    try {
      mutate(data, {
        onSuccess: () => {
          queryClients.invalidateQueries();
          setOpen(false);
        },
        onError: error => {
          toast.error(error?.response?.data?.error);
        },
      });
    } catch (e) {
      console.log(e);
    }

    // setLoading(true);
    // if (data) {
    //   await dispatch(webhookSubscription(data, setOpen));
    //   setLoading(false);
    // }
  }, [mutate, data, queryClients, setOpen]);

  return (
    <Modal
      show={open}
      modalTitle="Subscribe"
      onClose={setOpen}
      extraModalClasses="max-w-[448px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full rounded-b-none sm:rounded-b-lg absolute bottom-0 sm:relative lookup-modal"
      modalPosition="justify-center sm:justify-end"
    >
      <p className="my-6 px-6 text-left text-sm text-body">
        Set when and how you would like to get latest information about your
        user(s).
      </p>
      <form className="text-left">
        <div className="px-6">
          <label htmlFor="app_name" className="mt-6 mb-2 relative">
            App name
          </label>
          <Select
            defaultValue={selectedApp}
            value={selectedApp}
            onChange={app => setSelectedApp(app)}
            options={ALL_APPS}
            placeholder="Select an app..."
            components={{DropdownIndicator}}
            classNamePrefix="react-select"
            styles={customStyles}
            menuPlacement="auto"
          />

          <label htmlFor="webhook_url" className="mt-6">
            <span className="text-sm ">Webhook URL</span>
            <input
              type="url"
              id="webhook_url"
              className="mt-2"
              value={webhookUrl}
              onChange={e => setWebhookUrl(e.target.value)}
              placeholder="Add a webhook URL"
              required
            />
          </label>

          <label htmlFor="service_name" className="mt-6 mb-2 relative">
            Services name
          </label>
          <Select
            defaultValue={selectedService}
            value={selectedService}
            onChange={service => setSelectedService(service)}
            options={SERVICES}
            placeholder="Select a service..."
            components={{DropdownIndicator}}
            classNamePrefix="react-select"
            styles={customStyles}
            menuPlacement="auto"
          />
        </div>

        <div className="w-full mt-6 px-6 py-[14px] border-[0.5px] flex gap-4 border-transparent border-t-[#EFEFEF]">
          <SecondaryButton
            className="w-[50%] !h-10"
            buttonText="Cancel"
            onClick={() => setOpen(false)}
          />

          <PrimaryButton
            buttonText="Subscribe"
            className="w-[50%] !h-10"
            loading={isLoading}
            onClick={handeSubscribe}
            disabled={!Object.values(data).every(d => d)}
          />
        </div>
      </form>
    </Modal>
  );
}
